/* eslint-disable react-hooks/exhaustive-deps */
// export default IncidentRequest;
import CustomPagination from "components/CustomPagination";
import Loading from "components/Loading";
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import FurtherInvestigationForm from "pages/InvestigationFileDetail/modal/FurtherInvestigationForm";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchFurtherInvestigationByCRNumberAndIncidentRegNo } from "services/prosecutorPoliceService";
import { FurtherInvestigation, Roles } from "types";
import { errorHandler, hasRole } from "utils/helper";
import FurtherInvestigationInformationTab from "./fragment/FurtherInvestigationInformationTab";

const ITEMS_PER_PAGE = 9;

type Props = {
  crimeReferenceNumber?: string;
  incidentRegistrationNumber?: string;
};

const FurtherInvestigationList: React.FC<Props> = ({
  crimeReferenceNumber,
  incidentRegistrationNumber,
}) => {
  const { t } = useTranslation();
  const { showTooltip } = useTooltip();
  const { loginData } = useAuth();

  const [investigations, setInvestigations] = useState<FurtherInvestigation[]>(
    [],
  );
  const [loading, setLoading] = useState(true);

  const [isOpenFurtherInvestigation, setIsOpenFurtherInvestigation] =
    useState(false);
  const [selectedFile, setSelectedFile] = useState<FurtherInvestigation>();
  const [refetch, setRefetch] = useState(false);

  // const [search, setSearch] = useState("");
  const isPolice =
    hasRole(loginData?.roles, [Roles.member]) ||
    loginData?.role === "Member" ||
    loginData?.is_police;

  const [currentPage, setCurrentPage] = useState(0);

  const fetchData = () => {
    setLoading(true);
    fetchFurtherInvestigationByCRNumberAndIncidentRegNo(
      crimeReferenceNumber ?? "",
      incidentRegistrationNumber ?? "",
    )
      .then((data) => {
        // All further-investigation requests (police see only their station).
        setInvestigations(
          (data || []).filter((i) =>
            isPolice
              ? i?.police_station_id ===
                (typeof loginData?.user?.police_station === "object" &&
                loginData?.user?.police_station !== null
                  ? loginData.user.police_station.id
                  : undefined)
              : true,
          ),
        );
        setLoading(false);
      })
      .catch((error) => {
        showTooltip(errorHandler(error));
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [crimeReferenceNumber, incidentRegistrationNumber, refetch]);

  // const searchTerm = search.trim().toLowerCase();
  // const filteredInvestigations = investigations.filter((investigation) => {
  //   // 1️⃣ — existing text‑search fields
  //   const police_station_name =
  //     investigation?.police_station_name?.toString()?.toLowerCase() || "";
  //   const decision = investigation?.decision?.toString()?.toLowerCase() || "";
  //   const letter_number_sent =
  //     investigation?.letter_number_sent?.toString()?.toLowerCase() || "";
  //   const date_requested = investigation.date_requested
  //     ? new Date(investigation.date_requested)
  //         .toLocaleDateString()
  //         .toLowerCase()
  //     : "";

  //   const matchesText =
  //     police_station_name.includes(searchTerm) ||
  //     decision.includes(searchTerm) ||
  //     letter_number_sent.includes(searchTerm) ||
  //     date_requested.includes(searchTerm) ||
  //     date_requested.includes(searchTerm);

  //   // 2️⃣ — filter by tab
  //   if (activeTab === "Has E-File") {
  //     return matchesText && investigation?.is_efiling === true;
  //   } else if (activeTab === "No E-File") {
  //     return matchesText && investigation?.is_efiling !== true;
  //   }
  //   // 3️⃣ — tab "All" shows all incidents
  //   return matchesText;
  // });

  // Pagination logic
  const pageCount = Math.ceil(investigations.length / ITEMS_PER_PAGE);
  const paginatedInvestigations = investigations.slice(
    currentPage * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE + ITEMS_PER_PAGE,
  );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
      <div className="overflow-hidden bg-white shadow rounded-xl">
        {/* <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 p-4 border-b">
          <div className="relative w-full md:w-80">
            <span className="absolute inset-y-0 flex items-center text-gray-500 pointer-events-none left-3">
              🔍
            </span>
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(0); // Reset to first page on search
              }}
              placeholder="Search"
              className="w-full py-2 pl-10 pr-4 text-sm text-black placeholder-gray-600 bg-gray-200 rounded-md focus:outline-none"
            />
          </div>
        </div> */}

        {loading ? (
          <Loading label={t("loading_incidents")} />
        ) : (
          <div className="p-4">
            {paginatedInvestigations.length === 0 ? (
              <div className="text-center text-gray-500 py-8">
                {t("no_investigation_found")}
              </div>
            ) : (
              <div className="space-y-8">
                {paginatedInvestigations.map((investigation, idx) => (
                  <div key={investigation?.id ?? idx} className="space-y-3">
                    {investigation?.decision === "revice" && !isPolice && (
                      <div className="flex justify-end">
                        <button
                          type="button"
                          onClick={() => {
                            setSelectedFile(investigation);
                            setIsOpenFurtherInvestigation(true);
                          }}
                          className="px-4 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300"
                        >
                          {t("edit")}
                        </button>
                      </div>
                    )}
                    <FurtherInvestigationInformationTab
                      file={investigation}
                      setRefetch={setRefetch}
                    />
                  </div>
                ))}
              </div>
            )}
            {/* Pagination */}
            {pageCount > 1 && (
              <div className="flex justify-center my-8">
                <CustomPagination
                  pageCount={pageCount}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        )}
      </div>

      {isOpenFurtherInvestigation && selectedFile && (
        <FurtherInvestigationForm
          isOpen={isOpenFurtherInvestigation}
          action={"Edit"}
          file={undefined}
          furtherInvestigation={selectedFile}
          onClose={(refetch) => {
            setIsOpenFurtherInvestigation(false);
            if (refetch) {
              fetchData();
            }
          }}
        />
      )}
    </div>
  );
};

export default FurtherInvestigationList;
